enum DeploymentStage {
  PRODUCTION = 'production',
  STAGING = 'staging',
  ALPHA = 'alpha'
}

const DeploymentProfile = 'dor-metagraph-explorer';
const DeploymentFQDN = 'getdor.com';

const DeploymentRegions: Record<DeploymentStage, string> = {
  [DeploymentStage.PRODUCTION]: 'us-east-1',
  [DeploymentStage.STAGING]: 'us-east-2',
  [DeploymentStage.ALPHA]: 'us-west-1'
};

const DeploymentDomains: Record<DeploymentStage, string> = {
  [DeploymentStage.PRODUCTION]: 'explorer.getdor.com',
  [DeploymentStage.STAGING]: 'explorer-staging.getdor.com',
  [DeploymentStage.ALPHA]: 'explorer-alpha.getdor.com'
};

const DeploymentAPIDomains: Record<DeploymentStage, string> = {
  [DeploymentStage.PRODUCTION]: 'd13637uxelrbbg.cloudfront.net',
  [DeploymentStage.STAGING]: 'd1p7lgt6g8kehp.cloudfront.net',
  [DeploymentStage.ALPHA]: 'd1p7lgt6g8kehp.cloudfront.net'
};

const DeploymentEcosystemAPIDomains: Record<DeploymentStage, string> = {
  [DeploymentStage.PRODUCTION]: 'd2a4s9vrrsa9d4.cloudfront.net',
  [DeploymentStage.STAGING]: 'dn9tzq97tvcxj.cloudfront.net',
  [DeploymentStage.ALPHA]: 'dn9tzq97tvcxj.cloudfront.net'
};

const DeploymentMetagraphIds: Record<DeploymentStage, string> = {
  [DeploymentStage.PRODUCTION]: 'DAG0CyySf35ftDQDQBnd1bdQ9aPyUdacMghpnCuM',
  [DeploymentStage.STAGING]: 'DAG5kfY9GoHF1CYaY8tuRJxmB3JSzAEARJEAkA2C',
  [DeploymentStage.ALPHA]: 'DAG5kfY9GoHF1CYaY8tuRJxmB3JSzAEARJEAkA2C'
};

const DeploymentDAGExplorerDomains: Record<DeploymentStage, string> = {
  [DeploymentStage.PRODUCTION]: 'mainnet.dagexplorer.io',
  [DeploymentStage.STAGING]: 'integrationnet.dagexplorer.io',
  [DeploymentStage.ALPHA]: 'integrationnet.dagexplorer.io'
};

const isDeploymentStage = (value: unknown): value is DeploymentStage =>
  typeof value === 'string' &&
  Object.values(DeploymentStage).includes(value as any);

export {
  DeploymentStage,
  DeploymentProfile,
  DeploymentFQDN,
  DeploymentRegions,
  DeploymentDomains,
  DeploymentMetagraphIds,
  DeploymentDAGExplorerDomains,
  isDeploymentStage,
  DeploymentAPIDomains,
  DeploymentEcosystemAPIDomains
};
